<template>
    <div class="approve-setoran-content">
        <SOSlotBase :container-name="'approve-setoran-content'" :loading="!formReady">
            <template v-slot:title-bar v-if="!isOpenCamera">
                <div>
                    <SOTitleBar :page-title="`Setujui Settlement`" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="f-c-black f-regular f-14" v-if="formReady">
                    <div class="p-x-20" v-if="!isOpenCamera">
                        <p class="m-d-0">
                            {{ akunKeuangan.nama_akun }}
                            <span class="f-c-midgrey"> • {{ detailData.outlet.nama }}</span>
                        </p>
                        <p class="m-d-0 f-c-midgrey">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="m-d-8"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M1.16683 0.833334C1.62707 0.833334 2.00016 1.20643 2.00016 1.66667V6.77083C2.00016 7.32337 2.21966 7.85327 2.61036 8.24397C3.00106 8.63467 3.53096 8.85417 4.0835 8.85417H10.8217L8.59841 6.63092C8.27297 6.30549 8.27297 5.77785 8.59841 5.45241C8.92384 5.12697 9.45148 5.12697 9.77692 5.45241L13.4228 9.09824C13.7482 9.42368 13.7482 9.95132 13.4228 10.2768L9.77692 13.9226C9.45148 14.248 8.92384 14.248 8.59841 13.9226C8.27297 13.5972 8.27297 13.0695 8.59841 12.7441L10.8217 10.5208H4.0835C3.08893 10.5208 2.13511 10.1257 1.43185 9.42248C0.728584 8.71922 0.333496 7.7654 0.333496 6.77083V1.66667C0.333496 1.20643 0.706592 0.833334 1.16683 0.833334Z"
                                    fill="#6F7287"
                                />
                            </svg>
                            <span class="m-l-8">
                                {{ detailData.nama_akun_rekening }} - {{ detailData.nomor_rekening }}
                            </span>
                        </p>
                    </div>
                    <div class="separator-line m-t-16 m-d-16" v-if="!isOpenCamera" />
                    <div class="p-x-20" v-if="!isOpenCamera">
                        <div
                            class="d-grid-12 p-x-16 p-y-8 f-16 f-c-black f-regular m-d-16"
                            style="background: #F6F6F6; border-radius: 4px; border: 1px solid #C8D0DD;"
                        >
                            <div class="grid-cspan-6">
                                <p class="m-d-0 f-12 f-c-midgrey">Settlement</p>
                                <p class="m-d-0">{{ nominalSettlement | currency }}</p>
                            </div>
                            <div class="grid-cspan-6">
                                <p class="m-d-0 f-12 f-c-midgrey">Biaya MDR</p>
                                <p class="m-d-0">{{ biayaMdr | currency }}</p>
                            </div>
                        </div>
                        <div class="m-d-16">
                            <SOInputNominal
                                ref="nominal_diterima"
                                :prefix-left="true"
                                :placeholder="'1234'"
                                :id="`nominal_diterima`"
                                title="Nominal yang diterima"
                                :use-autocomplete="false"
                                :prefix="`Rp`"
                                :required="true"
                                v-model="nominal"
                                :max-value="nominalSettlement.toString()"
                            />
                            <label class="footer-note">Nominal uang yg masuk di rekening bank.</label>
                            <ErrorMessage
                                class="error"
                                label="Nominal yang diterima"
                                :validation="$v.posted.nominal_diterima"
                            />
                        </div>
                        <div class="m-d-16" @click="setDateToday('waktu_diterima')">
                            <SOInputDateTime
                                title="Diterima pada"
                                id="tgl-diterima"
                                placeholder="12 Jan 2021, 21:00"
                                :value="posted.waktu_diterima"
                                @get-date="changeDate($event, 'waktu_diterima')"
                                :required="true"
                            />
                            <label class="footer-note">Waktu uang yg masuk di rekening bank.</label>
                            <ErrorMessage class="error" label="Diterima pada" :validation="$v.posted.waktu_diterima" />
                        </div>
                    </div>
                    <div class="separator-line m-t-16 m-d-16" v-if="!isOpenCamera" />
                    <div class="p-x-20">
                        <SOButtonExpand
                            ref="biayaTambahan"
                            text="Data opsional"
                            id="opt-settlement"
                            :full-height="220"
                            @hook:mounted="onMountedBiaya"
                        >
                            <template v-slot:content>
                                <div>
                                    <div
                                        id="camera-2-content"
                                        :class="{
                                            fullScreen: isOpenCamera,
                                        }"
                                    >
                                        <SOUploadNota
                                            ref="uploadMutasiRekening"
                                            label="Bukti mutasi rekening"
                                            id="camera-2"
                                            :images="uploadMutasiRekening"
                                            :camera-open="camera.open"
                                            :full-size="camera.fullSize"
                                            :preview-img="selectedPreview"
                                            @setCamera="onToggleOpen"
                                            @setFullSize="onToggleFullSize"
                                            @setImages="setImages($event)"
                                            @deleteImg="onDeleteImg($event)"
                                            @preview="onSelected($event)"
                                            @hook:mounted="reloadImage"
                                        />
                                        <label class="footer-note">Sebagai bukti settlement telah sesuai.</label>
                                    </div>
                                    <div class="m-t-16">
                                        <SOInputRegular
                                            :title="'Catatan'"
                                            :placeholder="'Keterangan...'"
                                            v-model="posted.keterangan"
                                        />
                                    </div>
                                </div>
                            </template>
                        </SOButtonExpand>
                    </div>
                    <div class="separator-line m-t-16 m-d-16" v-if="!isOpenCamera" />
                    <div class="p-x-20 p-t-24" v-if="!isOpenCamera">
                        <SOButton
                            :primary="true"
                            :text="'Setujui Settlement'"
                            :full="true"
                            :id="`btn-approve-settlement`"
                            :loading="isFetching"
                            :disable="isFetching"
                            @action="doApprove"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import SOButton from "@/so-components/global/ui/SOButton";
import SOButtonExpand from "@/so-components/global/ui/SOButtonExpand";
import SOUploadNota from "@/so-components/global/ui/SOUploadNota.vue";
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime.vue";
import SOInputNominal from "@/so-components/global/input/SOInputNominal.vue";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import ErrorMessage from "@/component-items/ErrorMessage";

import { moduleName } from "../store/state";
import { required } from "vuelidate/lib/validators";

export default {
    name: "ApproveSettlementEdc",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOInputDateTime,
        SOInputNominal,
        ErrorMessage,
        SOButton,
        SOButtonExpand,
        SOInputRegular,
        SOUploadNota,
    },
    data() {
        return {
            formReady: false,
            camera: {
                open: false,
                fullSize: false,
            },
            nominal: {
                raw: null,
                formatted: "0",
            },
            isExpandBiaya: false,
            uploadMutasiRekening: [],
            selectedPreview: null,
            posted: {
                idedc: this.$route.params.id_mesin,
                idsettlement: this.$route.params.id_settlement,
                biaya_mdr: 0,
                nominal_settlement: 0,
                nominal_diterima: "",
                waktu_diterima: "",
                keterangan: "",
                bukti_mutasi_files: [],
            },
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
    },
    validations: {
        posted: {
            nominal_diterima: {
                required,
            },
            waktu_diterima: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            response: "response",
            isFetching: "isFetching",
            detailSettlementEdc: "detailSettlementEdc",
        }),
        isOpenCamera() {
            return this.camera.open || this.camera.fullSize;
        },
        detailData() {
            return this.detailSettlementEdc.detail_data;
        },
        getIdEdc() {
            return this.detailData.idedc;
        },
        nominalSettlement() {
            return this.detailData.nominal;
        },
        akunKeuangan() {
            return this.detailSettlementEdc.akun_keuangan_edc;
        },
        biayaMdr() {
            return this.nominal.raw ? this.nominalSettlement - this.nominal.raw : 0;
        },
    },
    methods: {
        ...mapActions({
            getDetailSettlementEdc: `${moduleName}/getDetailSettlementEdc`,
            setujuiSettlement: `${moduleName}/setujuiSettlement`,
            setFetching: `${moduleName}/setFetching`,
            resetsetListSettlementEdc: `settlementEdcGlobalModule/resetsetListSettlementEdc`,
            resetPagination: `settlementEdcGlobalModule/resetPagination`,
        }),
        back() {
            this.$router.go(-1);
        },
        async init() {
            await this.getDetailSettlementEdc(this.$route.params.id_settlement);
        },
        onMountedBiaya() {
            this.$refs.biayaTambahan.setExpand(this.isExpandBiaya);
        },
        setFormReady(val) {
            this.formReady = val;
        },
        setDateToday(target) {
            if (!this.posted[target]) {
                this.posted[target] = `${this.$moment().format("YYYY-MM-DD")}T${this.$moment().format("HH:mm")}`;
            }
        },
        changeDate(date, target) {
            this.posted[target] = date;
        },
        onToggleOpen() {
            this.camera.open = !this.camera.open;
            this.isExpandBiaya = true;
        },
        onToggleFullSize() {
            this.camera.fullSize = !this.camera.fullSize;
            this.isExpandBiaya = true;
        },
        setImages(data) {
            this.uploadMutasiRekening = data;
        },
        onDeleteImg(idx) {
            this.uploadMutasiRekening.splice(idx, 1);
        },
        onSelected(idx) {
            this.selectedPreview = idx;
        },
        reloadImage() {
            if (this.$refs.nominal_diterima) {
                this.$refs.nominal_diterima.nominal = this.nominal;
            }
            this.$refs.uploadMutasiRekening.handleImages();
        },
        errorValidation() {
            let { nominal_diterima, waktu_diterima } = this.$v.posted;
            nominal_diterima.$touch();
            waktu_diterima.$touch();

            return nominal_diterima.$invalid || waktu_diterima.$invalid;
        },
        setPosted() {
            this.posted.biaya_mdr = this.biayaMdr;
            this.posted.nominal_settlement = this.nominalSettlement;
            this.posted.nominal_diterima = this.nominal.raw;
            this.posted.bukti_mutasi_files = this.uploadMutasiRekening;
            this.posted.idedc = this.detailData.idedc;
        },
        async doApprove() {
            await this.setPosted();
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let posted = this.posted;

            if (!this.posted.idedc) {
                posted.idedc = this.getIdEdc;
            }
            let approve = this.setujuiSettlement(posted);
            approve
                .then((res) => {
                    this.setFetching(false);
                    this.resetsetListSettlementEdc();
                    this.resetPagination();
                    this.back();
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
<style scoped>
.fullScreen {
    padding-left: 0px;
    padding-right: 0px;
    margin-top: -95px;
    margin-left: -20px;
    position: absolute;
    width: 100vw;
    z-index: 200;
}
</style>
